import {generateClient} from 'aws-amplify/api';
import {GraphQLQuery} from '@aws-amplify/api';
import {getAccount} from './queries';
import {GetAccount} from '../types';
import {consoleApiConfig} from '../../../config/amplify/appsync';

// ⚠️ A SECOND CLIENT, POINTED AT console-api — not this app's default
// client. Amplify's default GraphQL endpoint is flexinet-users-api,
// which has no Account type at all, so calling it here returns a
// "Cannot query field" error that reads as a schema bug.
//
// `authMode: 'userPool'` matches console-api's @aws_cognito_user_pools
// directive. Amplify sends the ACCESS token for userPool auth, and the
// account claim rides on it.
const client = generateClient({
    endpoint: consoleApiConfig.endpoint,
    region: consoleApiConfig.region,
    authMode: 'userPool',
});

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetAccount>>({
        query: getAccount,
        variables: {id},
    });
    return response.data?.getAccount;
};
